// extracted by mini-css-extract-plugin
module.exports = {"TrustedTetailers":"TrustedTetailers_TrustedTetailers__gWh3L"};